import {
  useMutation
} from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryClient,
  UseMutationOptions,
  UseMutationResult
} from '@tanstack/react-query';

import type {
  RegisterPushDeviceRequest
} from '../model';

import { customInstance } from '../../mutator/custom-instance-new.ts';
import type { ErrorType , BodyType } from '../../mutator/custom-instance-new.ts';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * @summary Register this device for push notifications of the current session
 */
export const pushDeviceRegister = (
    registerPushDeviceRequest: BodyType<RegisterPushDeviceRequest>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/push-device`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: registerPushDeviceRequest, signal
    },
      options);
    }




export const getPushDeviceRegisterMutationKey = () => ['pushDeviceRegister'] as const;

export const getPushDeviceRegisterMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof pushDeviceRegister>>, TError,PushDeviceRegisterMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof pushDeviceRegister>>, TError,PushDeviceRegisterMutationVariables, TContext> => {

const mutationKey = getPushDeviceRegisterMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof pushDeviceRegister>>, PushDeviceRegisterMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  pushDeviceRegister(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PushDeviceRegisterMutationResult = NonNullable<Awaited<ReturnType<typeof pushDeviceRegister>>>
    export type PushDeviceRegisterMutationBody = BodyType<RegisterPushDeviceRequest>
    export type PushDeviceRegisterMutationError = ErrorType<void>
    export type PushDeviceRegisterMutationVariables = {data: BodyType<RegisterPushDeviceRequest>}

    /**
 * @summary Register this device for push notifications of the current session
 */
export const usePushDeviceRegister = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof pushDeviceRegister>>, TError,PushDeviceRegisterMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof pushDeviceRegister>>,
        TError,
        PushDeviceRegisterMutationVariables,
        TContext
      > => {
      return useMutation(getPushDeviceRegisterMutationOptions(options), queryClient);
    }
